import type { FC } from 'react';
import type { Button, StripeActionButton } from '@george-labs.com/design-system';
import type { ButtonProps } from '@george-labs.com/design-system/types/components/Button/NewButton';
import type { StripeActionButtonProps } from '@george-labs.com/design-system/types/components/Stripe';

import { isActionButtonDisplayed } from '../focus-page/FocusPageStripeService';

export interface Props extends ButtonProps, StripeActionButtonProps {
    'data-cy'?: string;
    isHidden?: boolean;
}
interface PropsWithButtonComponent extends Props {
    ButtonComponent: typeof Button | typeof StripeActionButton;
}

export const DetailPageStripeRightButton: FC<PropsWithButtonComponent> = ({
    isLoading,
    isHidden,
    'data-cy': dataCy,
    href,
    onClick,
    icon,
    component,
    children,
    sticky,
    ButtonComponent,
    ...passThroughProps
}) => {
    if (isHidden || !isActionButtonDisplayed(children, href, onClick)) {
        return null;
    }

    return (
        <ButtonComponent
            sticky={sticky}
            data-cy={dataCy}
            href={href}
            onClick={onClick}
            icon={icon}
            component={component}
            isLoading={isLoading}
            {...passThroughProps}
        >
            {children}
        </ButtonComponent>
    );
};
